import axios from 'axios';
import Message from 'shared_components/message';
import { axiosLabAPI, axiosResultReportAPI } from 'services/axios';
import { API_POST_METHOD, API_GET_METHOD, apiURLPrint } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchLabResult(payload) {

	const npayload = { 
		p_status: payload.status || 'ALL',
		p_fromdate: payload.fromDate || null,
		p_todate: payload.toDate || null,
		p_sample_id: payload.sampleSpecimenID || null,
		p_patient_demographics_id : payload.patientID || null,
		p_patientname: payload.patientName || null,
	 };


	try {
		const content = {
			method: API_POST_METHOD,
			url: `/result/search`,
			data: npayload
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			return data.RECORDS;
		} else {
			return [];
		}
	}
	catch (e) {
		showMessage(e);
		return false;
	}
}


export async function fetchLabResultExamItems(specimenId) {
	try {
		const content = {
			method: API_GET_METHOD,
			url: `/result/edit?p_sample_id=${specimenId}`,
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			return data.RECORDS[0];
		}
	}
	catch (e) {
		showMessage(e);
		return false;
	}
}

export async function saveLabResult(payload) {
	try {
		const content = {
			method: API_POST_METHOD,
			// url: `/lab/Result/saveresult`,
			url: `result/action`,
			// data: payload
			data: {
				p_action: payload.action,
				p_remarks: payload.remarks,
				p_userid: payload.userID,
				p_results_array: JSON.stringify(payload.results)
			}
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (error) {
		if (error.response && error.response.status === 400) {
			Message.error(error.response.data.error);
		}
		else {
			Message.error();
		}

		return false;
	}
}

export async function rejectLabResult(payload) {
	try {
		const content = {
			method: API_POST_METHOD,
			// url: `/lab/Result/rejecetresult`,
			url: `result/reject`,
			// data: payload
			data: {
				p_patient_demographics_id: payload.patientID,
				p_request_header_id: payload.requestID,
				p_sample_id: payload.sampleSpecimenID,
				p_section_id: payload.sectionID,
				p_specimen_id: payload.specimenID,
				p_userid: payload.userID,
				p_remarks: payload.remarks
			}
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (error) {
		if (error.response && error.response.status === 400) {
			Message.error(error.response.data.error);
		}
		else {
			Message.error();
		}

		return false;
	}
}

export async function getPrintPreview(spcmid) {
	try {
		const content = {
			method: API_GET_METHOD,
			url: `/lab/Result/printpreview/samplespecimenid/${spcmid}`,
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (error) {
		Message.error();
		return false;
	}
}

export async function getPrintPreviewV2(reqid, ssid) {
	try {
		const content = {
			method: 'GET',
			url: `/labreport/DefaultResultReport/${reqid}?ssid=${ssid}`,
		}

		const response = await axiosResultReportAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (error) {
		Message.error();
		return false;
	}
}

export async function generateReport(payload) {//grp approach for testing
	let details = null;

	try {
		const response = await axios({
			method: 'POST',
			url: `${apiURLPrint}labreport_api/generate.php`,
			data: JSON.stringify(payload),
		});


		const { data } = response;
		details = data;
	} catch (error) {
		throw error;
	}
	return details;
}

export async function fetchLineChartHistory(patientID, sectionID, specimenID) {
	let details = null;

	// const url = `/lab/Result/resultpreviousdeltacheck/PatientID/${patientID}/SectionID/${sectionID}/SpecimenID/${specimenID}`;
	const url = 'result/resultpreviousdeltacheck';
	
	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: url,
			headers: {
				'content-type': 'application/json',
			},
			params: {
				p_patient_id: patientID,
				p_section_id: sectionID,
				p_specimen_id: specimenID	
			}
		});
		const { data } = response;
		details = data;
		// console.log('response =>', response);
		// console.log('details=>', details);
	} catch (error) {
		console.log('error - test-linechart =>', error);
		return false;
	}

	return details;
}

export async function createPrintPdf(payload) {

	try {
		const content = {
			method: API_POST_METHOD,
			url: `/lab/PrintReport`,
			data: payload
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (error) {
		if (error.response && error.response.status === 404) {
			Message.error(error.response.data.error);
		}
		else {
			Message.error();
		}

		return false;
	}
}

export async function retrieveReport(appName, moduleName, reportName, requestID, sampleID) {
	let details = null;
	const url = `/reports/jrprintform/${appName}/${moduleName}/getreport2?reqid=${requestID}&ssid=${sampleID}`;

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: url,
			headers: {
				'content-type': 'application/json',
			},
		});
		const { data } = response;
		details = data;
		console.log('details=>', details);
		return details; // Return the fetched data if successful
	} catch (error) {
		if (error.response && error.response.status === 404) {
			Message.error(error.response.data.message);
		} else {
			console.error('An error occurred while fetching the report:', error);
		}
		return false; // Return false if there was an error
	}
}

export async function generateNewReport(appName, moduleName, parameters) {
	try {
		const content = {
			method: API_POST_METHOD,
			url: `/reports/jrprintform/${appName}/${moduleName}/getreport`,
			data: parameters
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (error) {
		if (error.response && error.response.status === 404) {
			Message.error(error.response.data.message);
		}
		else {
			Message.error();
		}

		return false;
	}
}

export async function printToPrinter(appName, moduleName, reportName, parameters) {
	try {
		const content = {
			method: API_POST_METHOD,
			url: `/reports/jrdirectprint/${appName}/${moduleName}`,
			data: parameters
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];

	}
	catch (error) {
		if (error.response && error.response.status === 404) {
			Message.error(error.response.data.message);
		}
		else {
			Message.error();
		}

		return false;
	}

}

export async function fetchIresult(specimenID) {
	try {
		const content = {
			method: API_GET_METHOD,
			url: `/lab/InstrumentResult/SampleSpecimenID/${specimenID}`,
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (error) {
		if (error.response && error.response.status === 404) {
			Message.error(error.response.data.message);
		}
		else {
			Message.error();
		}

		return false;
	}
}

export async function postTempIresult(payload) {
	try {
		const content = {
			method: API_POST_METHOD,
			url: `/lab/InstrumentResult/SelectInstrumentResult`,
			data: payload,
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (error) {
		// if(error.response && error.response.status === 404) {
		// 	Message.error(error.response.data.message);
		// }
		// else { 
		// Message.error();
		console.log('postTempIresult error =>', error);
		// }

		return false;
	}
}